<table
    [id]="id()"
    [attr.data-testid]="currentTestId()"
    [attr.data-styletarget]="id()"
    [attr.ui-type]="'table'"
    class="text-white w-full sm:hidden block "
>
    <tbody class="inline-block w-full">
        <tr
            [attr.data-testid]="currentTestId() + '-row-header'"
            [attr.data-styletarget]="id() + '-row-header'"
            [attr.ui-type]="'row-header'"
            class="font-caption grid px-2 bg-black text-sm "
            [class.grid-cols-7]="upsellEnabled()"
            [class.grid-cols-4]="!upsellEnabled()"
        >
            @for (colKey of colOrderSignal(); track colKey; let i = $index) {
            <th
                [id]="id() + '-row-header-' + headerRowSignal()[colKey].id"
                class="font-normal text-left p-[15px]"
                [attr.data-testid]="
                    currentTestId() + '-cole-header-' + headerRowSignal()[colKey].id
                "
                [attr.data-styletarget]="
                    id() + '-col-header-' + +headerRowSignal()[colKey].id
                "
                [attr.ui-type]="'col-header'"
                [cargoMd]="headerRowSignal()[colKey].label"
                [class.col-span-2]="(upsellEnabled() && i%6 === 0)"
            ></th>
            }
        </tr>
        @for(rowKey of rowOrder; track rowKey; let isOdd = $odd){
        <tr
            [attr.data-testid]="currentTestId() + '-row-' + rowKey"
            [attr.data-styletarget]="id() + '-row-' + rowKey"
            [attr.ui-type]="'row'"
            [class.bg-black]="isOdd"
            [class.tl-snapshot-table-row-grey]="!isOdd"
            class="font-body-2 grid px-2 bg-black"
            [class.grid-cols-7]="upsellEnabled()"
            [class.grid-cols-4]="!upsellEnabled()"
        >
            @for(colKey of colOrderSignal(); track colKey; let i = $index){
                @if(!!rows()?.[rowKey]?.[colKey]?.isLink){
                    <td
                        [id]="id() + '-' + rows()?.[rowKey]?.[colKey]?.id"
                        [attr.data-testid]="
                            currentTestId() + '-' + rows()?.[rowKey]?.[colKey]?.id
                        "
                        [attr.data-styletarget]="
                            id() + '-' + rows()?.[rowKey]?.[colKey]?.id
                        "
                        [attr.ui-type]="'cell'"
                        class="text-left p-[15px] !font-medium text-base !self-center"
                        [class.col-span-2]="(upsellEnabled() && i%6 === 0)"
                    >
                    <div class="font-[305]">{{ rows()?.[rowKey]?.[colKey]?.label }} </div>
                    @if (rows()?.[rowKey]?.[colKey]?.isUpsell) {
                        <a 
                        [href]="rows()?.[rowKey]?.[colKey]?.redirectUrl"
                        target="_blank"
                        class="text-dat-blue-500 no-underline hover:underline font-bold cursor-pointer"
                        (click)="dispacthSegmentEvent(rows()?.[rowKey]?.[colKey]?.linkLabel)"
                        >
                            {{rows()?.[rowKey]?.[colKey]?.linkLabel}}
                        </a>
                    }
                    @else {
                        <span 
                        class="text-dat-blue-500 no-underline hover:underline font-bold cursor-pointer" 
                        (click)="sendPayloadToIframe(rows()?.[rowKey]?.[colKey]?.redirectUrl)">
                            {{rows()?.[rowKey]?.[colKey]?.linkLabel}}
                        </span>
                    }
                </td>
                }
                @else {
                    <td
                        [id]="id() + '-' + rows()?.[rowKey]?.[colKey]?.id"
                        [attr.data-testid]="
                            currentTestId() + '-' + rows()?.[rowKey]?.[colKey]?.id
                        "
                        [attr.data-styletarget]="
                            id() + '-' + rows()?.[rowKey]?.[colKey]?.id
                        "
                        [attr.ui-type]="'cell'"
                        [cargoMd]="rows()?.[rowKey]?.[colKey]?.label"
                        class="text-left p-[15px] !font-medium text-base self-center"
                        [class.col-span-2]="(upsellEnabled() && i%6 === 0)"
                        
                    ></td>
                }
               
            }
        </tr>
        }
    </tbody>
</table>
<ul
    [id]="id() + '-mobile'"
    [attr.data-testid]="currentTestId()"
    [attr.data-styletarget]="id()"
    [attr.ui-type]="'table'"
    class="text-white w-full hidden sm:inline-block list-none p-0"
>
    @for(rowKey of rowOrder; track rowKey; let isOdd = $odd){
    <li
        class="text-left"
        [attr.data-testid]="currentTestId() + '-card-' + rowKey"
        [attr.data-styletarget]="id() + '-card-' + rowKey"
        [attr.ui-type]="'card'"
        [class.bg-black]="isOdd"
        [class.tl-snapshot-table-row-grey]="!isOdd"
    >
        @for(colKey of colOrderSignal(); track colKey){
        <div
            [id]="id() + '-' + rows()?.[rowKey]?.[colKey]?.id"
            [attr.data-testid]="
                currentTestId() + '-' + rows()?.[rowKey]?.[colKey]?.id
            "
            [attr.data-styletarget]="
                id() + '-' + rows()?.[rowKey]?.[colKey]?.id
            "
            [attr.ui-type]="'card-row'"
            class="flex justify-between !font-caption p-4 m-0"
        >
            <span class="iq-md" [cargoMd]="headerRowSignal()[colKey].cardLabel"></span>
            @if(!!rows()?.[rowKey]?.[colKey]?.isLink){
                @if(rows()?.[rowKey]?.[colKey]?.isUpsell) {
                    <div class="grid text-right">
                        <span class="text-white font-[305]">{{ rows()?.[rowKey]?.[colKey]?.label }}</span> 
                        <a 
                        [href]="rows()?.[rowKey]?.[colKey]?.redirectUrl"
                        target="_blank"
                        class="text-dat-blue-500 no-underline hover:underline font-bold cursor-pointer" 
                        >
                           {{rows()?.[rowKey]?.[colKey]?.linkLabel}}
                        </a>
                    </div>
                }
                @else {
                    <span 
                    class="text-dat-blue-500 no-underline hover:underline font-bold cursor-pointer" 
                    (click)="sendPayloadToIframe(rows()?.[rowKey]?.[colKey]?.redirectUrl)">
                        {{rows()?.[rowKey]?.[colKey]?.linkLabel}}
                    </span>
                }
            }
            @else {
                <span class="iq-md" [cargoMd]="rows()?.[rowKey]?.[colKey]?.label"></span>
            }
            
        </div>
        }
    </li>
    }
</ul>
<div [attr.data-json-info]="'snapshot-table'" class="hidden">
    {{ data() | json }}
</div>
<meta name="description" [content]="data() | json" />
